module.exports = __webpack_public_path__ + "static/media/clap-dark.df47ced4.png";